/**
 * EEATTrustBar — compact authority + trust strip that lives near the
 * top of every high-intent landing page (Pricing, /features, /vs,
 * /alternatives, /insights).
 *
 * IMPORTANT: every claim below MUST be verifiable. We removed the
 * fabricated corporate-registry number, review count, SOC 2 badge,
 * and specific HQ city until we have documentary proof of each.
 * Overclaiming here is punished harder by Google's spam team than
 * underclaiming.
 */
import { ShieldCheck, Landmark, MapPin, FileCheck2, Globe2, Lock } from "lucide-react";

const CLAIMS = [
  { icon: Landmark,   label: "Central Rentals Canada Inc. · Canadian-owned",  href: "/about" },
  { icon: MapPin,     label: "Data hosted in Canada",                          href: "/security" },
  { icon: ShieldCheck,label: "PIPEDA-compliant data processing",               href: "/security" },
  { icon: FileCheck2, label: "Editorial policy",                               href: "/editorial-policy" },
  { icon: Lock,       label: "Corrections policy",                             href: "/editorial-policy#corrections" },
  { icon: Globe2,     label: "Bilingual EN / FR · All 13 provinces",           href: "/property-management/ontario" },
];

export default function EEATTrustBar({ testid = "eeat-trust-bar" }) {
  return (
    <section
      data-testid={testid}
      className="w-full py-4"
      style={{
        background: "linear-gradient(180deg,#ffffff 0%,#f8fafc 100%)",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "1px solid #e2e8f0",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-wrap items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm">
        {CLAIMS.map(({ icon: Icon, label, href }, i) => {
          const external = href.startsWith("http");
          return (
            <a
              key={i}
              href={href}
              target={external ? "_blank" : undefined}
              rel={external ? "noopener noreferrer" : undefined}
              data-testid={`${testid}-item-${i}`}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "6px 12px",
                borderRadius: "9999px",
                background: "#ffffff",
                color: "#0f172a",
                textDecoration: "none",
                border: "1px solid #e2e8f0",
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}
            >
              <Icon className="w-3.5 h-3.5 shrink-0" style={{ color: "#059669" }} />
              <span>{label}</span>
            </a>
          );
        })}
      </div>
    </section>
  );
}

